import {call, put, takeLatest} from "redux-saga/effects";
import {API} from "../../../api/api";
import {SystemServerVersionsActionTypes} from "../actions/actionTypes";
import {SystemServerVersionsAPI} from "../api/api";

function* getSystemServerVersions(action) {
    try {
        const core_versions = yield call(() => SystemServerVersionsAPI.getSystemServerVersions());

        yield put({
            type: SystemServerVersionsActionTypes.GET_SYSTEM_SERVER_VERSIONS_SUCCESS,
            payload: {
                core_versions: core_versions.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting system server versions.");

        yield put({
            type: SystemServerVersionsActionTypes.GET_SYSTEM_SERVER_VERSIONS_FAIL,
            message: e.message
        });
    }
}

export function* getSystemServerVersionsWatcher() {
    yield takeLatest(SystemServerVersionsActionTypes.GET_SYSTEM_SERVER_VERSIONS, getSystemServerVersions);
}
